import { useEffect, useState } from 'react';
import { api } from '../../lib/apiClient.js';
import { useCopilotController } from '../../app/CopilotController.jsx';
import { IconSparkles } from '../../components/icons.jsx';

// S3 — "AI quotes ingested data" affordance on the project finance surface.
// On mount it fetches the finance-change visual (prior -> ingested obligated delta
// built ONLY from committed record values). When the endpoint returns a snapshot
// it renders a sparkle button; clicking opens the EXISTING PRIME Copilot rail with
// a chart-specific question and the visual attached as authoritative context, so
// the grounded answer quotes the ingested figure and cites the ingestion job.
// When the endpoint returns null it renders nothing (honest empty) — nothing has
// been ingested for this project, so there is no change to explain.
const FINANCE_CHANGE_QUESTION = "What changed in this project's financials this month?";

export function AskFinancialChangeButton({ projectId, autoSubmit = true, className = '' }) {
  const { openWith } = useCopilotController();
  const [visual, setVisual] = useState(null);

  useEffect(() => {
    let active = true;
    const scopeId = String(projectId || '').trim();
    if (!scopeId) {
      setVisual(null);
      return () => {};
    }
    (async () => {
      try {
        const res = await api.get(
          `/projects/${encodeURIComponent(scopeId)}/financial-change-visual`,
        );
        const data = res?.data ?? res ?? null;
        if (active) setVisual(data && Array.isArray(data.series) ? data : null);
      } catch {
        if (active) setVisual(null);
      }
    })();
    return () => {
      active = false;
    };
  }, [projectId]);

  if (!visual) return null;

  return (
    <button
      type="button"
      className={`btn ghost sm explain-chart-btn ask-financial-change-btn${className ? ` ${className}` : ''}`}
      data-testid="ask-financial-change-button"
      title="Ask PRIME what changed in this project's financials"
      aria-label="Ask PRIME what changed in this project's financials this month"
      onClick={() => openWith({ question: FINANCE_CHANGE_QUESTION, visual, autoSubmit })}
    >
      <IconSparkles size={15} />
      <span>Ask PRIME: what changed this month?</span>
    </button>
  );
}
